var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPercentDown(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.0975 11.3023L12.0575 10.3423L8.80416 7.08896L6.61083 9.28229C6.35083 9.54229 5.93083 9.54229 5.67083 9.28229L1.67083 5.27562C1.41083 5.01562 1.41083 4.59562 1.67083 4.33562C1.93083 4.07563 2.35083 4.07563 2.61083 4.33562L6.1375 7.86896L8.33083 5.67563C8.59083 5.41563 9.01083 5.41563 9.27083 5.67563L12.9975 9.39563L13.9575 8.43563C14.1642 8.22896 14.5242 8.37563 14.5242 8.66896V11.529C14.5242 11.7156 14.3775 11.8623 14.1908 11.8623H11.3308C11.0375 11.869 10.8908 11.509 11.0975 11.3023Z",
    fill: "#E41E1E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPercentDown);
export default __webpack_public_path__ + "static/media/PercentDown.0e856ef7e0b76d56e04fa122047c1999.svg";
export { ForwardRef as ReactComponent };